import React, { useState } from "react";
import "./GenericTab.css";

const getNestedValue = (obj, path) =>
  path.split('.').reduce((acc, part) => acc && acc[part], obj);
interface GenericTabProps {
  data: any[];
  config: any;
  openItemPopup?: (id: Number | string) => void;
  lookups?: Record<string, any>;
}

const GenericTab: React.FC<GenericTabProps> = ({ data, config, openItemPopup, lookups = {} }) => {
  const { categoryField, categories, displayFields } = config;
  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (!(date instanceof Date) || isNaN(date.getTime())) return value;
    return date.toLocaleDateString("he-IL");
  };


  const [openStates, setOpenStates] = useState(
    Object.fromEntries(categories.map(({ label }) => [label, true]))
  );

  const toggleCategory = (label) => {
    setOpenStates(prev => ({
      ...prev,
      [label]: !prev[label]
    }));
  };

  return (
    <div className="generic-tables" dir="rtl">
      {categories.map(({ label, color }) => {
        const isOpen = openStates[label];
        const items = data.filter(item => getNestedValue(item, categoryField) === label);

        return (
          <div key={label} className="category-table-wrapper">
            <div
              className="category-pill"
              style={{ backgroundColor: color }}
              onClick={() => toggleCategory(label)}
            >
              {label} {isOpen ? "▲" : "▼"}
            </div>

            {isOpen && (
              <div className="category-table">
                <table className="data-table">
                  <thead>
                    <tr>
                      {displayFields.map(field => (
                        <th key={field.key}>{field.label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => (
                      <tr
                        key={index}
                        className="task-button"
                        onClick={(e) => {
                          e.stopPropagation(); // מונע מהכרטיס כולו להפעיל את ה־onClick
                          openItemPopup(item[config.idField]);
                        }}
                        role="button"
                        tabIndex={0}
                      >
                        {displayFields.map(field => {
                          let value = getNestedValue(item, field.key);

                          if (
                            field.lookup &&
                            lookups[field.lookup] &&
                            typeof value !== "object"
                          ) {
                            const match = lookups[field.lookup].find(entry => {
                              const idKey = Object.keys(entry).find(k => k.toLowerCase().includes("id"));
                              return entry[idKey] === value;
                            });

                            if (match) {
                              if (field.lookupLabel.includes(",")) {
                                const parts = field.lookupLabel
                                  .split(",")
                                  .map(k => match[k]?.trim())
                                  .filter(Boolean);
                                value = parts.join(" ");
                              } else {
                                value = match[field.lookupLabel] || value;
                              }
                            }
                          }

                          return (
                            <td key={field.key}>
                              {field.key === "levelUrgencyStatus"
                                ? value == 1 ? "נמוכה"
                                  : value == 2 ? "רגילה"
                                    : value == 3 ? "חשובה"
                                      : value == 4 ? "דחופה"
                                        : "לא מוגדר"
                                : field.format === "₪"
                                  ? `${value} ₪`
                                  : field.format === "date"
                                    ? formatDate(value)
                                    : value}
                            </td>

                          );

                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default GenericTab;
